import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { SplitButton } from 'primereact/splitbutton';
// import { Menu } from "primereact/menu";


// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
// import CalendarWeek from "../../../Base/Components/Form/CalendarWeek";
import Card from "../../../Base/Components/Card/Card";
import { toastShow } from "../../../Base/Services/ToastService";
import { getDatesProduccion } from "../../../Base/Services/Moment/Luxon";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import Loader from "../../../Base/Components/Loader/Loader";

// ------------------- CONSULTAS A LA API---------------------------
import { getAgentesCompras, getVerPreciosCompras } from "../../../Base/API/IT/Accesos/AccesosRequests";
import { getRequisasDetalle } from "../../../API/Compras/RequisiscionCompras/PurchaseRequestDetails";
import { EliminarItemRequisa, EliminarRequisa } from "../../../API/Compras/Requisas/PurchaseRequest";
import { getRequisasFecha } from "../../../API/Compras/RequisiscionCompras/PurchaseRequest";
import { getListadoDetalleOrdenes, getListadoOrdenes } from "../../../API/Compras/Ordenes/OrdenesComprasRequests";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import ArchivosRequisicion from "./Requisas/CrudRequisa/EncabezadoRequisa/ArchivosRequisicion";
import Purchases from "./Requisas/Detalles/PurcharesDetails";
import CrudRequisa from "./Requisas/CrudRequisa/CrudRequisa";
import ListadoRequisaTab from "./ListadoRequisasTab";
import ModalFull from "../../../Base/Components/Dialog/ModalFull";
import OrdenesComprasCrud from "./OrdenesCompras/CrudOrdenesCompras/OrdenesComprasCrud";
import { confirmDialog } from "primereact/confirmdialog";
import ReportePR from "./Requisas/Reporte/ReportePR";
import CalendarioOperativo from "../../../Base/Components/Form/CalendarioOperativo";

const PurchareRequestsScreen = ({MateriaPrima = false}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const toastDialog = useRef(null);
  const { config } = useContext(ConfigContext);
  // const menuImprimir = useRef(null);

  const [loading, setLoading] = useState(false);
  const [accesoColumnas, setAccesoColumnas] = useState([]);
  const [agentesCompras, setAgentesCompras] = useState([]);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [detalles, setDetalles] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [ordenDialog, setOrdenDialog] = useState(false);
  const [requisaToShow, setRequisaToShow] = useState(null);
  const [orderToShow, setOrderToShow] = useState(null);
  const [selectedDetalle, setSelectedDetalle] = useState([]);
  const [detallesPR, setDetallesPR] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [dataOrdenes, setDataOrdenes] = useState([]);
  const [dataDetalle, setDataDetalle] = useState([]);
  const [habilitar, setHabilitar] = useState(true);
  const [showReporte, setShowReporte] = useState(false);
  const [Language, setLanguage] = useState('es');


  const obtenerAgentesCompras = async () => {
    const tempo = await getAgentesCompras();
    let lista = [];
    let Agents = [];
    tempo.forEach((e) => {
      Agents.push(e);
      lista.push(e.UserName);
    });
    setAgentesCompras(Agents);
  };

  const eliminarDetalleRequisicion = async () => {

    if(selectedDetalle?.length === 0){
      toastShow(toast, 'warn', "Advertencia", 'Seleccione al menos un detalle.')
      return
    }

    confirmDialog({
      message: "¿Estás seguro de eliminar?",
      header: "Eliminar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      accept: () => {
        selectedDetalle.forEach(async (select) => {
          if(select.IdStatus === 20){
            toastShow( toast, "error", "Error", "El Detalle de requisa seleccionado ya está en una orden de compra.");
          }else{
            if (selectedDetalle.length > 0) {
              const detallesCancelados = selectedDetalle.every((detalle) => detalle.IdStatus === 15);
      
              if (detallesCancelados) {
                toastShow( toast, "error", "Error", "El Detalle de requisa seleccionado ya está cancelados.");
                return;
              }
      
              const isListado = activeIndex;
              let response;
              if (activeIndex === 0) {
                response = await EliminarItemRequisa(selectedDetalle.filter((detalle) => detalle.IdStatus !== 15));
              } else {
                response = await EliminarRequisa(selectedDetalle.filter((detalle) => detalle.IdStatus !== 15));
              }
      
              if (response[0].ESTADO === 1) {
                toastShow( toast, "success", "Cancelado", isListado ? "Requisa cancelada correctamente." : "Detalle de requisición cancelado correctamente.");
                actualizarRequisas();
              } else {
                toastShow(toast,"error", "Error", response[0].MENSAJE);
              }
      
            } else {
              toastShow( toast, "error", "No se puede cancelar", "Seleccione al menos un detalle de la requisición.");
            }
          }
    
        })
      },
      rejectLabel: "No",
      reject: () => {}, 
      style: { backgroundColor: "white" },
    });
  };

  const actualizarRequisas = async () => {
    setLoading(true);
    const d = getDatesProduccion(dates);
    const t = await getRequisasDetalle(d);
    setDetalles(t);
    setLoading(false);
  };

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido.");
      return;
    }
    setLoading(true);
    const d = getDatesProduccion(dates);
    const t = await getRequisasDetalle(d);
    const verPrecios = await getVerPreciosCompras();
    const PurchaseR = await getRequisasFecha(d);
    obtenerAgentesCompras();
    setAccesoColumnas(verPrecios);
    let dataEnc = MateriaPrima ? t.filter(i => i?.MateriaPrima === 1) : t.filter(i => i?.MateriaPrima !== 1)
    let dataDet = MateriaPrima ? PurchaseR.filter(i => i?.MateriaPrima === 1) : PurchaseR.filter(i => i?.MateriaPrima !== 1)
    setDetalles(dataEnc);
    setDetallesPR(dataDet);
    setLoading(false);
  };


  const actualizarCompras = async () => {
    setLoading(true);
    const d = getDatesProduccion(dates);
    const t = await getListadoOrdenes(d);
    const dd = await getListadoDetalleOrdenes(d);
    setDataOrdenes(t);
    setDataDetalle(dd);
    setLoading(false);
  };

  // Items para cambiar el idioma.
  const items = [
    {
      label: "Inglés",
      icon: "",
      command: () => {
        if (selectedDetalle?.length === 0) {
          toastShow(
            toast,
            "warn",
            "Advertencia",
            "Seleccione una requisicion a imprimir"
          );
          return;
        }

        if (selectedDetalle?.length > 20) {
          toastShow(
            toast,
            "warn",
            "Advertencia",
            "Solo se imprimirán las primeras 20 requisas."
          );
        }

        setLanguage("en");
        setShowReporte(true);
      },
    },
    {
      label: "Español",
      icon: "",
      command: () => {
        if (selectedDetalle?.length === 0) {
          toastShow(
            toast,
            "warn",
            "Advertencia",
            "Seleccione una requisicion a imprimir"
          );
          return;
        }

        if (selectedDetalle?.length > 20) {
          toastShow(
            toast,
            "warn",
            "Advertencia",
            "Solo se imprimirán las primeras 20 requisas."
          );
        }

        setLanguage("es");
        setShowReporte(true);
      },
    },
  ];

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && requisaToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog(null);
          setRequisaToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog(null);
      setRequisaToShow(null);
      setHabilitar(true);
    }
  };

  useEffect(() => {
    // getInfo();
    setTitlePage(getLabel(baseLang, "requisas", config.language));
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        visible={showDialog}
        onHide={() => {cerrarConfirmacion()}}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <CrudRequisa
          idRequisa={requisaToShow}
          setRequisaToShow={setRequisaToShow}
          showDialog={showDialog}
          actualizarRequisas={actualizarRequisas}
          actualizarRequisasScreen={actualizarRequisas}
          setOrderToShow={setOrderToShow}
          setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          MateriaPrima={MateriaPrima}
        />
      </Dialog>

      <ModalFull
        header="Orden de compras"
        visible={ordenDialog}
        onHide={(e) => {
          setOrdenDialog(null);
        }}
        contenido={
          <OrdenesComprasCrud
            PurchaseOrder={orderToShow}
            ordenDialog={ordenDialog}
            setOrdenDialog={setOrdenDialog}        
            actualizarCompras={actualizarCompras}
            setRequisaDialog={setShowDialog}
            setRequisaToShow={setRequisaToShow}
          />
        }
      />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "requisas", config.language)}</h2>
            {/* <CalendarWeek
              date={dates}
              setDate={setDates}
              buscar={getInfo}
              selectionMode="range"
            /> */}
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
              tipo="mesCalendario"
            />
            <Button icon="pi pi-refresh" tooltip="Buscar" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialog(true)}
            />

            {/* Botón de impresión */}
            <div className="d-flex flex-row">
              <SplitButton
                label=""
                icon="pi pi-print"
                tooltip="Imprimir"
                onClick={() => {
                  if (selectedDetalle?.length === 0) {
                    toastShow(
                      toast,
                      "warn",
                      "Advertencia",
                      "Seleccione una requisicion a imprimir"
                    );
                    return;
                  }

                  if (selectedDetalle?.length > 20) {
                    toastShow(
                      toast,
                      "warn",
                      "Advertencia",
                      "Solo se imprimirán las primeras 20 requisas."
                    );
                  }

                  setLanguage("es");
                  setShowReporte(true);
                }}
                model={items}
              />
            </div>
      
            <ArchivosRequisicion
              PurchaseRequest={selectedDetalle[0]?.PurchaseRequest}
              IdPurchaseRequest={selectedDetalle[0]?.IdPurchaseRequest}
            />

            <Button
              icon="pi pi-times"
              type="button"
              className="p-button-danger listado__botones"
              onClick={() => eliminarDetalleRequisicion()}
              tooltip="Cancelar"
              tooltipOptions={{
                className: "purple-tooltip",
                position: "top",
              }}
              style={{ marginLeft: 1.5 }}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading}/>
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Requisas">
                <Purchases
                  detalles={detalles}
                  accesoColumnas={accesoColumnas}
                  toast={toast}
                  loading={loading}                 
                  setDetalles={setDetalles}
                  setShowDialog={setShowDialog}
                  setRequisaEdit={setRequisaToShow}
                  setOrdenDialog={setOrdenDialog}
                  setOrderToShow={setOrderToShow}
                  selectedDetalle={selectedDetalle}
                  setSelectedDetalle={setSelectedDetalle}
                  actualizarRequisasScreen={actualizarRequisas}
                />
              </TabPanel>
              <TabPanel header="Listado">
                <ListadoRequisaTab
                  listadoRequisas={detallesPR}
                  loading={loading}
                  setShowDialog={setShowDialog}
                  setRequisaEdit={setRequisaToShow}
                  selectedDetalle={selectedDetalle}
                  setSelectedDetalle={setSelectedDetalle}
                />
              </TabPanel>
            </TabView>
          </div>
        }
      />


      {showReporte && (
        <ReportePR
          showReporte={showReporte}
          setShowReporte={setShowReporte}
          selectedDetalle={selectedDetalle?.slice(0, 20)}
          setLanguaje={setLanguage}
          Language={Language}
        />
      )}
    </div>
  );
};

export default PurchareRequestsScreen;
